import { BASE } from './index';
import axios from './http';
const share = {
    // 线上签约
    suppliercontracturl: params => axios.post(`${BASE.PRO1}/supplier/contract/url`,  params ),
};

export default share;
